const normalizeName = (value) =>
  typeof value === "string" ? value.trim().replace(/\s+/g, " ") : "";

/**
 * Split a personal name while retaining middle names with the first-name part.
 * A single-word name is treated as a first name with no last name.
 */
export const splitPersonName = (value) => {
  const normalizedName = normalizeName(value);
  if (!normalizedName) return { firstName: "", lastName: "" };

  const parts = normalizedName.split(" ");
  if (parts.length === 1) {
    return { firstName: parts[0], lastName: "" };
  }

  return {
    firstName: parts.slice(0, -1).join(" "),
    lastName: parts.at(-1),
  };
};